import { useState } from 'react';
import { useLazyMessagesByConversationQuery } from '../../../graphql/graphql';

export interface DefaultConversationFilter {
	groupId?: string;
}

interface Props {
	getConversationsQuery: ReturnType<
		typeof useLazyMessagesByConversationQuery
	>[0];
	customSkip?: number;
	defaultFilter?: DefaultConversationFilter;
}

export default function useConversations({
	getConversationsQuery,
	customSkip,
	defaultFilter = {},
}: Props) {
	const [page, setPage] = useState(1);
	const getConversations = (filter: any) => {
		const skip = customSkip ?? 20;
		getConversationsQuery({
			...filter,
			...defaultFilter,
			pagination: {
				...filter.pagination,
				skip: (page - 1) * skip,
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getConversations, getNextPage, page, setPage };
}
